import { ref, onMounted } from "vue";
import axiosInstance from "@/utils/axiosInstance";

/**
 * Fetch whether record date/time fields should be shown on public record forms.
 * Defaults to false (hidden) when the API is unavailable — matches prior behavior.
 */
export async function fetchShowRecordDateTime() {
  try {
    const { data } = await axiosInstance.get("/settings/show_record_datetime");
    return Boolean(data.bool_value);
  } catch (error) {
    console.warn("Failed to load show_record_datetime setting:", error);
    return false;
  }
}

/**
 * Vue composable for record forms.
 */
export function useShowRecordDateTime() {
  const showRecordDateTime = ref(false);

  onMounted(async () => {
    showRecordDateTime.value = await fetchShowRecordDateTime();
  });

  return { showRecordDateTime };
}
